import { axios } from "@/core/axios";

interface ScreenshotRequest {
    url: string;
    width?: number;
    height?: number;
    waitFor?: number;
}

interface ScreenshotResponse {
    screenshot: string; // base64 PNG
}

/**
 * Calls the backend screenshot endpoint to capture a URL as a PNG image.
 * Used for cross-origin iframe content that can't be captured client-side.
 */
export async function captureScreenshot(params: ScreenshotRequest): Promise<string> {
    const payload: Record<string, unknown> = {
        url: params.url,
        width: params.width ?? 1200,
        height: params.height ?? 800,
    };
    if (params.waitFor !== undefined) {
        payload.waitFor = params.waitFor;
    }
    const response = await axios.post<ScreenshotResponse>("/screenshot", payload);

    return response.data.screenshot;
}

interface ProxyImageResponse {
    image: string; // base64
    contentType: string;
}

/**
 * Fetches an external image through the backend proxy to bypass CORS.
 * Returns a complete data-URI string ready to use as an img src.
 */
export async function proxyImage(url: string): Promise<string> {
    const response = await axios.post<ProxyImageResponse>("/proxy-image", { url });
    const { image, contentType } = response.data;
    return `data:${contentType};base64,${image}`;
}
